module.exports = __webpack_public_path__ + "img/logo.98c40a6c.svg";